// importiert von Tilman. Bei Fehlern gern auf ihn zurückkommen
import { Injectable, OnDestroy } from '@angular/core';
// import { UserService } from './user.service';
import { NGXLogger } from 'ngx-logger';
import { EmployeeConfigDto, EmployerDto, UserConfigDto, UserGrantDto } from '../api/exa/model/models';
import { EmployerService } from './employer.service';
import { NgxLoggerLevel } from 'ngx-logger';

@Injectable({
  providedIn: 'root',
})
export class AppCacheService implements OnDestroy {
  className = 'AppCacheService';

  cache = {};
  currentUser: UserGrantDto = null;
  currentEmployer: EmployerDto = null;
  currentEmployeeConfig: EmployeeConfigDto = null;

  constructor(
    //private userService: UserService,
    private employerService: EmployerService,
    private log: NGXLogger
  ) {
    this.log.debug(this.className + '- init');
    // auskommentiert von Tilman, Userservice wird noch nicht gebraucht.
    // this.userService.onAuthenticate().subscribe(
    //   user => {
    //     if (!user) {
    //       // delete the cache
    //       this.cache = {};
    //     }
    //     this.currentUser = user;
    //   }
    // );
    // this.employerService.onSelectEmployer().subscribe(
    //   employer => {
    //     this.currentEmployer = employer;
    //   }
    // );

    // this.employerService.onEmployeeConfigChanged().subscribe(
    //   employeeConfig => {
    //     this.currentEmployeeConfig = employeeConfig;
    //     if(this.currentEmployeeConfig && !this.employerService.isTemporaryEmployer()){
    //       this.updateCacheWithEmployeeConfig();
    //     }
    //   }
    // );
  }

  ngOnDestroy(): void {
    this.log.debug(this.className + '- destroy');
  }

  reset() {
    this.cache = {};
  }

  store(key: string, data: any) {
    this.cache[key] = data;
  }

  remove(key: string) {
    if (this.hasKey(key)) {
      return delete this.cache[key];
    }
    return null;
  }

  read(key: string): any {
    if (this.hasKey(key)) {
      return this.cache[key];
    }
    return null;
  }

  hasKey(key: string): boolean {
    return this.cache.hasOwnProperty(key);
  }

  storePageRequest(viewName: string, pageRequestName: string, pageRequestDto: any) {
    if (!this.currentEmployer) {
      return;
    }
    const key = this.currentEmployer.username + '.' + viewName + '.' + pageRequestName;
    this.store(key, pageRequestDto);
  }

  loadPageRequest(viewName: string, pageRequestName: string): any {
    if (!this.currentEmployer) {
      return;
    }
    const key = this.currentEmployer.username + '.' + viewName + '.' + pageRequestName;
    return this.read(key);
  }

  removePageRequest(viewName: string, pageRequestName: string) {
    if (!this.currentEmployer) {
      return;
    }
    const key = this.currentEmployer.username + '.' + viewName + '.' + pageRequestName;
    this.remove(key);
  }

  storeSetting(viewName: string, settingName: string, setting: any) {
    if (!this.currentEmployer) {
      return;
    }
    const key = this.currentEmployer.username + '.' + viewName + '.' + settingName;
    this.store(key, setting);
    if (!this.employerService.isTemporaryEmployer()) {
      this.handleEmployeeConfigSetting(settingName, setting);
    }
  }

  loadSetting(viewName: string, settingName: string, defaultValue?: any): any {
    if (!this.currentEmployer) {
      return defaultValue;
    }
    const key = this.currentEmployer.username + '.' + viewName + '.' + settingName;
    if (this.hasKey(key)) {
      return this.read(key);
    } else {
      return defaultValue;
    }
  }

  removeSetting(viewName: string, settingName: string) {
    if (!this.currentEmployer) {
      return;
    }
    const key = this.currentEmployer.username + '.' + viewName + '.' + settingName;
    if (this.hasKey(key)) {
      this.remove(key);
      if (!this.employerService.isTemporaryEmployer()) {
        this.handleEmployeeConfigSetting(settingName, null);
      }
    }
  }

  handleEmployeeConfigSetting(settingName: string, value: any) {
    let updateNeeded = true;
    if (!this.currentEmployeeConfig.webappSettings && value == null) {
      return;
    } else if (!this.currentEmployeeConfig.webappSettings) {
      // create new set
      this.currentEmployeeConfig.webappSettings = {};
    }
    switch (settingName) {
      case 'showFields':
        this.currentEmployeeConfig.webappSettings.showFields = value;
        break;
      case 'showEvents':
        this.currentEmployeeConfig.webappSettings.showEvents = value;
        break;
      case 'showLocations':
        this.currentEmployeeConfig.webappSettings.showLocations = value;
        break;
      case 'showOfflineMachines':
        this.currentEmployeeConfig.webappSettings.showOfflineMachines = value;
        break;
      case 'showDirection':
        this.currentEmployeeConfig.webappSettings.showDirection = value;
        break;
      case 'machinePathLength':
        this.currentEmployeeConfig.webappSettings.machinePathLength = value;
        break;
      default:
        updateNeeded = false;
    }
    if (updateNeeded) {
      this.log.debug('employeeConfig update: ', this.currentEmployeeConfig);
      this.employerService.updateEmployeeConfig(this.currentEmployeeConfig).subscribe((ret) => {});
    }
  }

  updateCacheWithEmployeeConfig() {
    const employerUsername = this.currentEmployeeConfig.employerUsername;
    this.log.debug('employeeConfig cache update: ', this.currentEmployeeConfig);
    if (this.currentEmployeeConfig && this.currentEmployeeConfig.webappSettings) {
      if (this.currentEmployeeConfig.webappSettings.showFields != null) {
        const key = employerUsername + '.DashboardViewComponent.showFields';
        this.store(key, this.currentEmployeeConfig.webappSettings.showFields);
      }
      if (this.currentEmployeeConfig.webappSettings.showEvents != null) {
        const key = employerUsername + '.DashboardViewComponent.showEvents';
        this.store(key, this.currentEmployeeConfig.webappSettings.showEvents);
      }
      if (this.currentEmployeeConfig.webappSettings.showLocations != null) {
        const key = employerUsername + '.DashboardViewComponent.showLocations';
        this.store(key, this.currentEmployeeConfig.webappSettings.showLocations);
      }
      if (this.currentEmployeeConfig.webappSettings.showOfflineMachines != null) {
        const key = employerUsername + '.DashboardViewComponent.showOfflineMachines';
        this.store(key, this.currentEmployeeConfig.webappSettings.showOfflineMachines);
      }
      if (this.currentEmployeeConfig.webappSettings.showDirection != null) {
        const key = employerUsername + '.DashboardViewComponent.showDirection';
        this.store(key, this.currentEmployeeConfig.webappSettings.showDirection);
      }
      if (this.currentEmployeeConfig.webappSettings.machinePathLength != null) {
        const key = employerUsername + '.DashboardViewComponent.machinePathLength';
        this.store(key, this.currentEmployeeConfig.webappSettings.machinePathLength);
      }
    }
  }
}
